const Platform = Object.freeze({
    HFC: 'HFC',
    AE: 'AE',
    FWA: 'FWA',
    FTTH: 'FTTH',
});
export default Platform;
